import { Button as ButtonV2 } from "../Button";
import { AddToAListIconPNG, resolveImageSrc } from "../Icons";
import { Typo } from "../Typo";
import type { MarketingBannersTranslations } from "./types";

/**
 * Empty state for the marketing-banners table and banner library.
 * Strings come either from an explicit `title`/`subtitle` (e.g. the banner
 * library passes its own copy) or fall back to the `translations` object.
 * Pass `onReset` to render a reset-filters button.
 */
export const MarketingBannersEmptyDisplay = ({
  translations,
  title,
  subtitle,
  onReset,
  resetButtonLabel,
}: {
  translations?: MarketingBannersTranslations;
  title?: string;
  subtitle?: string;
  onReset?: () => void;
  resetButtonLabel?: string;
} = {}) => {
  const resolvedTitle = title ?? translations?.states.empty.title ?? "";
  const resolvedSubtitle =
    subtitle ?? translations?.states.empty.subtitle ?? "";

  return (
    <div className="flex h-[384px] flex-col items-center justify-center gap-6">
      <img
        src={resolveImageSrc(AddToAListIconPNG)}
        alt="empty-icon"
        className="size-16"
      />
      <div className="flex flex-col items-center gap-4">
        <Typo type="labelLG">{resolvedTitle}</Typo>
        <Typo type="bodyMD" textColor="text-text-secondary">
          {resolvedSubtitle}
        </Typo>
      </div>
      {onReset && (
        <ButtonV2 variant="brand" onClick={onReset}>
          {resetButtonLabel ?? "Reset"}
        </ButtonV2>
      )}
    </div>
  );
};
